export const convertArrayToObject = (array, key) => {
    const initialValue = {};

    return array.reduce((obj, item) => ({
        ...obj,
        [item[key]]: item
    }), initialValue);
};
